import { render, staticRenderFns } from "./CardScheduleConsult.vue?vue&type=template&id=64c2174a"
import script from "./CardScheduleConsult.vue?vue&type=script&lang=js"
export * from "./CardScheduleConsult.vue?vue&type=script&lang=js"
import style0 from "./CardScheduleConsult.vue?vue&type=style&index=0&id=64c2174a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports